import { render } from "./Wagon.vue?vue&type=template&id=84e0578a"
import script from "./Wagon.vue?vue&type=script&lang=js"
export * from "./Wagon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/Icons/Wagon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "84e0578a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('84e0578a', __exports__)) {
    api.reload('84e0578a', __exports__)
  }
  
  module.hot.accept("./Wagon.vue?vue&type=template&id=84e0578a", () => {
    api.rerender('84e0578a', render)
  })

}


export default __exports__